export const myHistory = [
    {
        year : 2007,
        points : [
            "I wrote my first line of code back in October 2008.",
            "My young hands wrote Lua code that was really messy and duplicated",
            "I did not know what a boolean was, I thought it was a trash can."
        ]
    },
    {
        year : 2012,
        points : [
            "I saw planet Venus crossing the disk of the Sun (June 2022)"
        ]
    },
    {
        year : 2016,
        points : [
            "I graduated from Howard S Billings High School",
            "Maintained Honour Roll status thoughout all secondary education years",
        ]
    },
    {
        year : 2019,
        points : [
            "I graduated from Dawson College in Analytical Chemistry",
            "Practiced hands-on training in lab tech skills and working in a team setting",
        ]
    },
    {
        year : 2020,
        points : [
            "I started studying HTML, CSS and Java at Dawson College",
            "The pandemic sentenced me to 3 years at home due to restrictions.",
        ]
    },
    {
        year : 2022,
        points : [
            "I started learning React and C# and Node.Js",
        ]
    },
    {
        year : 2023,
        points : [
            "This is when I started this website.",
            "I graduated from Dawson College in Computer Science",
        ]
    },
    {
        year : 2024,
        points : [
            "Created Open Journal Bonfire! TypeScript-based MERN application",
            "Witnessed the Total Solar Eclipse on April 8, 2024 ☀️🌑☀️",
            "Got hired at Tim Hortons!",
        ]
    },
    {
        year : 2025,
        points : [
            "Created Pillars V.S. Killers Tower Defense with TypeScript and PixiJS!",
            "Present time, I still have many worlds to explore.",
        ]
    }
]